import { DEFAULT_CHART_PALETTE } from '@chartv2';
import { hash32 } from '@helpers';

export const getLensColorVar = (lens: string): string => {
  const index = parseInt(hash32(lens), 16) % DEFAULT_CHART_PALETTE.length;
  return DEFAULT_CHART_PALETTE[index];
};
